import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AllItems from "../components/Views/AllItems";

import EditForm from "../components/Views/EditForm";
import Container from "./Container.jsx";

class PurchasedServicesContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("purchased_services");
        this.state = {
            ...this.state,
            getParams: { ...this.globalSearch.search.purchased_services },
        };
    }

    componentDidMount = async () => {
        await this.getAuxData();
    };

    paramsChangeHandler = (newParams) => {
        this.getAllItems(newParams);
    };

    getBackLink = () => this.datasource.routes().home;

    render = () => {
        if (this.state.error && this.state.error.status == 403) {
            return <Route render={() => <Redirect to="/hotels" replace />} />;
        }

        const serviceCategories =
            this.props?.auxData?.service_categories &&
            this.props.auxData.service_categories;

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        // if (!reservations_services) {
        //     return <Paper elevation={3}>
        //         <Box mt={4}>
        //             <LinearProgress mt={3} />
        //         </Box>
        //     </Paper>;
        // }

        const arrCategories = [];

        serviceCategories?.forEach((category) => {
            arrCategories.push({ [category.name]: category.id });
        });

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title={"Купленные услуги"}
                        columns={{
                            id: "Id",
                            reservation_number: "Номер заявки",
                            service_id: "Название услуги",
                            price: "Стоимость",
                            comment: "Пожелание гостя",
                            status: "Статус",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        hotelsData={this.state.hotelsData}
                        fields={fields}
                        viewAction={this.getViewLink}
                        copyObject={this.copyRate}
                        editAction={this.getEditLink}
                        toggleAction={this.toggleItem}
                        removeAction={this.removeItem}
                        thisPurchasedServices={true}
                        serviceCategories={arrCategories}
                        globalSearch={this.globalSearch}
                        updateGlobalSearch={this.updateGlobalSearch}
                        paramsChangeHandler={this.paramsChangeHandler}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        title="Редактирование Купленной услуги"
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        submitActionApply={this.updateItemWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        thisPurchasedServices={true}
                    />
                </Route>
            </Switch>
        );
    };
}

export default PurchasedServicesContainer;
